import { PrizePoolAction, WinnersAction } from "../actions";
import { ApiCaller, Utils } from "../../config";
import { put } from "redux-saga/effects";
import {
  GET_LUCKYDRAW_CONFIG_ENDPOINT,
  GET_LUCKYDRAW_POOL_DETAILS_ENDPOINT,
  GET_LUCKYDRAW_POOL_ENDPOINT,
  GET_LUCKYDRAW_WINNERS_ENDPOINT,
  GET_PRIZEPOOL_DETAILS_ENDPOINT,
  GET_PRIZEPOOL_ENDPOINT,
  UPDATE_LUCKYDRAW_CONFIG_ENDPOINT,
  UPDATE_LUCKYDRAW_WINNERS_ENDPOINT,
  WINNER_ENDPOINT,
  WINNER_UPDATE_ENDPOINT,
} from "../../config/variables";

export default class PrizePoolMiddleware {
  static *GetPrizePool() {
    try {
      let res = yield ApiCaller.Get(`${GET_PRIZEPOOL_ENDPOINT}`);
      if (res?.status == 200) {
        yield put(PrizePoolAction.GetPrizePool_Success(res?.data?.data));
      }
    } catch (err) {}
  }
  static *GetPrizePoolDetail({ id, cb }) {
    try {
      let res = yield ApiCaller.Get(
        `${GET_PRIZEPOOL_DETAILS_ENDPOINT}${id}/prize-pool`
      );
      if (res?.status == 200) {
        yield put(PrizePoolAction.GetPrizePool_Detail_Success(res?.data?.data));
        cb();
      }
    } catch (err) {}
  }

  static *UpdatePrizePool_Detail({ payload, cb }) {
    console.log("payload", payload, cb);
    const { requiredUsers, id } = payload;
    try {
      let res = yield ApiCaller.Patch(
        `${GET_PRIZEPOOL_DETAILS_ENDPOINT}${id}/prize-pool`,
        {},
        { requiredUsers }
      );
      if (res?.status == 200) {
        yield put(
          PrizePoolAction.UpdatePrizePool_Detail_Success(res?.data?.data)
        );
        cb();
      }
    } catch (err) {}
  }

  static *GetLuckydrawConfig() {
    
    
    try {
      let res = yield ApiCaller.Get(`${GET_LUCKYDRAW_CONFIG_ENDPOINT}`);
      if (res?.status == 200) {
        yield put(PrizePoolAction.GetLuckydrawConfig_Success(res?.data));
      }
    } catch (err) {}
  }

  static *UpdateLuckydrawConfig_Detail({ payload, cb }) {
    console.log("requiredUserspayload", payload, cb);
    const { requiredUsers,winningAmount, id } = payload;
    try {
      let res = yield ApiCaller.Patch(
        `${UPDATE_LUCKYDRAW_CONFIG_ENDPOINT}${id}`,
        {},
        { requiredUsers, winningAmount }
      );
      if (res?.status == 200) {
        yield put(
          PrizePoolAction.UpdateLuckydrawConfig_Detail_Success(res?.data?.data)
        );
        cb();
      }
    } catch (err) {}
  }

  static *GetLuckydrawPools(payload) {
    const { limit, offSet } = payload?.payload;
    console.log(payload,"ddddddddddddddddd");
    
    try {
      let res = yield ApiCaller.Get(`${GET_LUCKYDRAW_POOL_ENDPOINT}?limit=${limit}&offset=${offSet}`);
      console.log(res, "fedsefsf");
      if (res?.status == 200) {
        yield put(PrizePoolAction.GetLuckydrawPools_Success(res?.data?.data));
      }
    } catch (err) {}
  }

  static *GetLuckydrawPoolsDetail(payload) {
    const { limit, offSet, id } = payload?.payload;
    console.log(payload,"ddddddddddddddddd");
    
    try {
      let res = yield ApiCaller.Get(`${GET_LUCKYDRAW_POOL_DETAILS_ENDPOINT}${id}?limit=${limit}&offset=${offSet}`);
      console.log(res, "fedsefsf");
      if (res?.status == 200) {
        yield put(PrizePoolAction.GetLuckydrawPoolsDetail_Success(res?.data?.data));
      }
    } catch (err) {}
  }

  static *GetLuckydrawWinners(payload) {
    const { limit, offSet } = payload?.payload;
    try {
      let res = yield ApiCaller.Get(`${GET_LUCKYDRAW_WINNERS_ENDPOINT}?limit=${limit}&offset=${offSet}`);
      console.log(res, "fedsefsf");
      if (res?.status == 200) {
        yield put(PrizePoolAction.GetLuckydrawWinners_Success(res?.data?.data));
      }
    } catch (err) {}
  }

  static *UpdateLuckydrawWinners({ payload, cb }) {
    console.log("requiredUserspayload", payload);
    try {
      let res = yield ApiCaller.Patch(
        `${UPDATE_LUCKYDRAW_WINNERS_ENDPOINT}${payload}`,
      );
      if (res?.status == 200) {
        yield put(
          PrizePoolAction.UpdateLuckydrawWinners_Success(res?.data?.data)
        );
        cb();
      }
    } catch (err) {}
  }
  // static *GetPrizePoolDetail({id, cb}) {
  //   try {
  //     let res = yield ApiCaller.Get(
  //       `${GET_PRIZEPOOL_DETAILS_ENDPOINT}${id}/prize-pool`
  //     );
  //     if (res?.status == 200) {
  //       yield put(PrizePoolAction.GetPrizePool_Detail_Success(res?.data?.data));
  //       cb()
  //     }

  //   } catch (err) { }
  // }

  // static *UpdatePrizePool_Detail({payload, cb}) {
  //   console.log("payload", payload, cb);
  //   const { requiredUsers, id } = payload;
  //   try {
  //     let res = yield ApiCaller.Patch(
  //       `${GET_PRIZEPOOL_DETAILS_ENDPOINT}${id}/prize-pool`,{},{requiredUsers}
  //     );
  //     if (res?.status == 200) {
  //       yield put(PrizePoolAction.UpdatePrizePool_Detail_Success(res?.data?.data));
  //       cb()
  //     }

  //   } catch (err) { }
  // }
}
